export default __webpack_public_path__ + "static/media/NotFoundError.57a3f8f3.svg";